import theme, { LOADED_THEME } from '../../services/theme'

export default {
    emptyIcon: LOADED_THEME.Datatable.emptyIcon,
    emptyText: LOADED_THEME.Datatable.emptyText,
    empty: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        fontSize: '24px'
    },
    root: {
        borderRadius: LOADED_THEME.Datatable.radius,
        marginBottom: '5px',
        width: '100%',
        backgroundColor: theme.palette.Datatable.background
    },
    grid: {
        height: '365px',
        border: `1px solid ${theme.palette.Datatable.grid.border}`,
        backgroundColor: theme.palette.Datatable.grid.background,
        [`& .row-error-`]: {
            backgroundColor: theme.palette.Datatable.row.error
        },
        [`& .MuiDataGrid-columnHeaders`]: {
            color: theme.palette.Datatable.header.color,
            borderRadius: 0,
            borderTopLeftRadius: LOADED_THEME.Datatable.radius,
            borderTopRightRadius: LOADED_THEME.Datatable.radius,
        },
        [`& .MuiDataGrid-columnHeader`]: {
            backgroundColor: theme.palette.Datatable.header.background
        },
        [`& .MuiDataGrid-cell`]: {
            color: theme.palette.Datatable.row.color,
            border : 0
        }
    }
}